import {type ServerDefinedItemData, serverDefinedItem} from './server-defined-item'
import type CommandPalette from '../command-palette-element'
import {CommandPaletteItemGroupElement} from '../command-palette-item-group-element'
import {JumpToItem} from './jump-to-item'
import type {Query} from '../query'
import type {Token} from '../command-palette-token-element'

interface SearchLinkItemData extends ServerDefinedItemData {
  titleScope: string
}

@serverDefinedItem
export class SearchLinkItem extends JumpToItem {
  static searchableScopeTypes = ['owner', 'repository']
  titleScope: string

  static create(query: Query) {
    let titleScope: string
    let path: string

    const tokens = [...query.scope.tokens]

    while (tokens.length > 0 && !this.searchableScopeTypes.includes(tokens[tokens.length - 1]!.type)) {
      tokens.pop()
    }

    let lastToken: Token | undefined

    if (tokens.length > 0) {
      lastToken = tokens[tokens.length - 1]
    } else {
      lastToken = undefined
    }

    if (lastToken && lastToken.type === 'repository') {
      const nwo = tokens.map(t => t.text).join('/')

      titleScope = `in ${nwo}`
      path = `/${nwo}/search?q=${query.text}`
    } else if (lastToken && lastToken.type === 'owner') {
      const orgSearchQuery = `org:${lastToken.text} ${query.text}`
      titleScope = `in ${lastToken.text}`
      path = `/search?q=${orgSearchQuery}`
    } else {
      titleScope = `across all of GitHub`
      path = `/search?q=${query.text}`
    }

    return new SearchLinkItem({
      title: `Search ${query.text}${titleScope}`,
      typeahead: '',
      priority: -10,
      score: -10,
      group: CommandPaletteItemGroupElement.footerGroupId,
      action: {
        type: 'jump_to',
        description: '',
        path,
      },
      icon: {
        type: 'octicon',
        id: 'search-color-fg-muted',
      },
      titleScope,
    })
  }

  constructor(data: SearchLinkItemData) {
    super(data)
    this.titleScope = data.titleScope
  }

  autocomplete(_commandPalette: CommandPalette) {
    // nothing to autocomplete
  }

  override calculateScore(_queryText: string): number {
    return 0
  }
}
